<div class="{{ className }}">
  <div class="{{ className }}__wrapper" tabindex="0">
    <table
      (matSortChange)="storeSort($event, view)"
      [dataSource]="originalData"
      [matSortActive]="matSortActive"
      [matSortDirection]="matSortDirection"
      [style.border-radius]="borderRadius ? borderRadius : ''"
      [style.box-shadow]="boxShadow ? boxShadow : ''"
      class="without-scroll {{ borderRadius ? 'radius' : '' }}"
      id="table{{ view }}"
      mat-table
      matSort>
      <ng-container *ngFor="let data of dataTable; let i = index" [matColumnDef]="data.colData">
        <!--checkbox marca filas para hacer una petición en otro componente-->
        <ng-container *ngIf="data.colType === 'check'">
          <th
            *matHeaderCellDef
            [style.display]="data.showCol ? 'table-cell' : 'none'"
            [style.width]="data.width ?? 'auto'"
            class="{{ className }}__th-{{ i }}  {{
              data.align ? className + '__' + data.align : ''
            }}"
            mat-header-cell>
            <mat-checkbox
              (change)="$event ? masterAvailableToggle() : null"
              [checked]="selectionIncluded.hasValue() && isAllIncludedSelected()"
              [labelPosition]="'before'"
              [style.display]="data.showCol ? 'table-cell' : 'none'"
              [style.width]="data.width ?? 'auto'"
              class="{{ className }}__th-{{ i }}  {{
                data.align ? className + '__' + data.align : ''
              }}"
              color="purple"
              id="table{{ view }}-checkbox-header">
            </mat-checkbox>
          </th>
          <td
            *matCellDef="let element"
            [style.display]="data.showCol ? 'table-cell' : 'none'"
            [style.width]="data.width ?? 'auto'"
            class="{{ className }}__td-{{ i }}  {{
              data.align ? className + '__' + data.align : ''
            }}"
            mat-cell>
            <mat-checkbox
              (change)="$event ? selectionIncluded.toggle(element) : null"
              (click)="$event.stopPropagation()"
              (ngModelChange)="onSelectedIncludedChange($event, element)"
              [ngModel]="getCondiction(element)"
              [checked]="selectionIncluded.isSelected(element)"
              [labelPosition]="'before'"
              [style.display]="data.showCol ? 'table-cell' : 'none'"
              [style.width]="data.width ?? 'auto'"
              class="{{ className }}__td-{{ i }}  {{
                data.align ? className + '__' + data.align : ''
              }}"
              color="purple"
              id="table{{ view }}-checkbox-{{ element._id }}">
            </mat-checkbox>
            {{ element.id | json }}
          </td>
        </ng-container>
        <!--text-->
        <ng-container *ngIf="data.colType === 'text'">
          <th
            *matHeaderCellDef
            [style.display]="data.showCol ? 'table-cell' : 'none'"
            [style.max-width]="data.width ?? 'auto'"
            [style.width]="data.width ?? 'auto'"
            class="{{ className }}__th-{{ i }}  {{
              data.align ? className + '__' + data.align : ''
            }}"
            disableClear
            mat-header-cell
            mat-sort-header>
            <span
              [style.max-width]="data.width ?? 'auto'"
              class="ellipsis {{ data.align ? className + '__' + data.align : '' }}"
              matTooltip="{{ data.labels }}"
              matTooltipClass="{{ theme }} custom-tooltip"
              matTooltipPosition="before"
              >{{ data.labels }}</span
            >
          </th>
          <td
            *matCellDef="let element"
            [style.display]="data.showCol ? 'table-cell' : 'none'"
            [style.width]="data.width ?? 'auto'"
            class="{{ className }}__td-{{ i }}  {{
              data.align ? className + '__' + data.align : ''
            }}"
            id="{{ className }}__td-{{ utilService.removeSpacesAndInsertScript(element.name) }}"
            mat-cell>
            <span
              [style.max-width]="data.width ?? 'auto'"
              class="ellipsis"
              matTooltip="{{ element[data.colData] }}"
              matTooltipClass="{{ theme }} custom-tooltip"
              matTooltipPosition="before"
              >{{ element[data.colData] }}</span
            >
          </td>
        </ng-container>
      </ng-container>

      <ng-container matColumnDef="nodata">
        <td
          *matFooterCellDef
          [colSpan]="displayedColumns.length"
          class="no-data"
          mat-cell
          mat-footer-cell>
          {{ noDataLabel ?? 'No data found' }}
        </td>
      </ng-container>
      <tr *matHeaderRowDef="displayedColumns; sticky: true" mat-header-row></tr>
      <tr *matRowDef="let row; columns: displayedColumns; let k = index" mat-row></tr>
      <tr *matFooterRowDef="['nodata']" [hidden]="(originalData?.length ?? 0) > 0" mat-footer-row></tr>
    </table>
  </div>
</div>